import { FormState } from "react-hook-form";
import { FormInputs } from "../Components/Content";
import { getUrlParam } from "../utils";

// Campaign packet constant
export const CAMPAIGN_PACKET = "professional";

// Durable flag marking that the user actively activated the New Company campaign.
// Distinct from the "newCampaignActivated" flag, which is a one-shot GA marker that
// Content.tsx consumes and removes on the activation reload — that one cannot be used
// for the render/payload decision because it is cleared mid-load.
export const NEW_CAMPAIGN_ACTIVATED_KEY = "newCampaignUserActivated";

export function getTradeRegistrationYear() {
  const tradeRegisterDate = sessionStorage.getItem("tradeRegisterDate");

  if (!tradeRegisterDate) {
    return null;
  }

  const parsedTradeRegisterDate = new Date(tradeRegisterDate);
  return parsedTradeRegisterDate.getFullYear();
}

export function isNewCompany(tradeRegistrationYear?: number | undefined) {
  const registrationYear = tradeRegistrationYear ?? getTradeRegistrationYear();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  if (registrationYear === currentYear) {
    return true;
  }
  else if (registrationYear === currentYear - 1) {
    if (currentDate < new Date(currentYear, 2, 1, 0, 0, 0)) {
      return true;
    }
  }

  return false;
}

export function isNewCampaignActivated() {
  return (
    isNewCompany() &&
    getUrlParam("packet") === CAMPAIGN_PACKET &&
    sessionStorage.getItem(NEW_CAMPAIGN_ACTIVATED_KEY) === "true"
  );
}

// Clears the durable activation flag once the user has moved off the campaign
// packet, so returning to "professional" later re-prompts instead of silently
// re-activating. Called at app load; every packet change reloads the page.
export function clearNewCampaignActivationIfPacketChanged() {
  if (getUrlParam("packet") !== CAMPAIGN_PACKET) {
    sessionStorage.removeItem(NEW_CAMPAIGN_ACTIVATED_KEY);
  }
}

export function activateNewCompanyCampaign(
  formValues: FormInputs,
  formState: FormState<FormInputs>
) {
  sessionStorage.setItem("newCampaignActivated", "true");
  sessionStorage.setItem(NEW_CAMPAIGN_ACTIVATED_KEY, "true");
  changePacket(formValues, formState, CAMPAIGN_PACKET);
}

function changePacket(
  formValues: FormInputs,
  formState: FormState<FormInputs>,
  packet: string
) {
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set("packet", packet);

  for (const [key, value] of Object.entries(formValues)) {
    if (typeof value !== "string") {
      continue;
    }

    if (Object.keys(formState.errors).includes(key)) {
      continue;
    }

    if (value === undefined || value === "") {
      continue;
    }

    sessionStorage.setItem(key, value as string);
  }

  window.location.href = `${
    window.location.pathname
  }?${searchParams.toString()}`;
}
